module.exports = __webpack_public_path__ + "static/sport/bgi-dialog.a68e740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottery/bgi-dialog.png
// module id = jKDk
// module chunks = 0